import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { format, parseISO } from 'date-fns';
import { useCallback, useMemo, useState } from 'preact/compat';
import TextInput from '@widgets/shared/components/form-controls/TextInput';
import API from '@widgets/shared/API/connection';
import FormError from '@enquiryForm/components/FormError';
import LoadingSpinner from '@widgets/shared/components/LoadingSpinner';
import Styles from './styles';
export default function Signature(props) {
    const { onConfirm, agreedTerms } = props;
    const { watch, setError, clearErrors, formState: { errors }, } = useFormContext();
    const [working, setWorking] = useState(false);
    const signature = watch('SignatureName');
    const date = watch('SignatureDate');
    const handleSignatureSubmission = useCallback(async (ev) => {
        clearErrors('SignatureName');
        setWorking(true);
        try {
            const success = await API.signature(agreedTerms, signature, date);
            if (!success) {
                throw new Error('Failed to authorise signature.');
            }
            onConfirm(ev);
        }
        catch (err) {
            setError('SignatureName', {
                type: 'manual',
                message: err.message,
            });
        }
        finally {
            setWorking(false);
        }
    }, [
        agreedTerms,
        clearErrors,
        date,
        onConfirm,
        setError,
        signature,
    ]);
    const renderButtonText = useCallback(() => {
        if (working) {
            return (_jsx(LoadingSpinner, { colourOverride: "#888", style: { height: 24, width: 24 } }));
        }
        return 'I Agree';
    }, [working]);
    const dateStr = useMemo(() => format(parseISO(date), 'yyyy-MM-dd HH:mm:ss'), [date]);
    return (_jsxs(Styles.Wrapper, { children: [_jsx("div", { className: "slab form", children: _jsxs("div", { className: "signature", children: [_jsx("span", { className: "signature__title h4", children: "Enter your name in the field below to sign" }), _jsxs("div", { className: "signature__row", children: [_jsx(TextInput, { inputAttrs: {
                                        type: 'text',
                                        name: 'SignatureName',
                                        id: 'signature',
                                        placeholder: 'Name Surname',
                                        className: 'form__control',
                                    }, labelAttrs: {
                                        htmlFor: 'signature',
                                        text: 'Forename and Surname',
                                        isFieldRequired: true,
                                        hidden: true,
                                    } }), _jsx("div", { id: "signature-preview", className: "signature__preview", children: signature }), _jsx("time", { className: "signature__time", dateTime: parseISO(date).toISOString(), children: dateStr })] })] }) }), (errors && errors.SignatureName) && (_jsx(FormError, { children: errors.SignatureName })), _jsx(Styles.ConfirmButton, { type: "button", className: "btn", onClick: handleSignatureSubmission, disabled: working, children: renderButtonText() })] }));
}
